import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { noop } from 'ui-components/default-props/noop';

import { ShipStationAppId } from '../constants';
import Global from '../../store/global-selectors';

export const useCuiContextProps = () => {
  const isAdmin = useSelector(Global.selectUserisSysAdmin);
  const userId = useSelector(Global.selectUserCurrentUserId);
  const sellerId = useSelector(Global.selectSellerSellerId);
  const country = useSelector(Global.selectSellerHomeCountry);

  const user = useMemo(() => ({ country, isAdmin, userId, sellerId }), [country, isAdmin, userId, sellerId]);

  return useMemo(
    () => ({
      appId: ShipStationAppId,
      user,
      parentHostUrl: window.location.href,
      onComponentLoaded: noop,
    }),
    [user],
  );
};
